import type { AxiosInstance } from 'axios';

import {
  confirmSessionUseCase,
  forcePaymentUseCase,
  generateSessionUseCase,
  listPaymentMethodsUseCase,
} from '@subscriptions/application/use-cases';
import type { PaymentMethodUseCases } from '@subscriptions/composition/types';
import { createPaymentMethodHttpClient } from '@subscriptions/infrastructure/api/PaymentMethodHttpClient';
import { createPaymentMethodApiMapper } from '@subscriptions/infrastructure/mappers/PaymentMethodApiMapper';
import { createPaymentMethodApiRepository } from '@subscriptions/infrastructure/repositories/PaymentMethodApiRepository';

/**
 * Assembles all payment method use cases with their dependencies.
 *
 * @param httpClientSubscription - Axios bound to parrot-subscriptions-api
 */
export const createPaymentMethodUseCases = (httpClientSubscription: AxiosInstance): PaymentMethodUseCases => {
  const paymentMethodHttpClient = createPaymentMethodHttpClient({ httpClientSubscription });
  const mapper = createPaymentMethodApiMapper();
  const repository = createPaymentMethodApiRepository({ httpClient: paymentMethodHttpClient, mapper });

  return {
    listPaymentMethods: listPaymentMethodsUseCase(repository),
    generateSession: generateSessionUseCase(repository),
    confirmSession: confirmSessionUseCase(repository),
    forcePayment: forcePaymentUseCase(repository),
  };
};
